import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toastmasters-club',
  templateUrl: './toastmasters-club.component.html',
  styleUrls: ['./toastmasters-club.component.scss']
})
export class ToastmastersClubComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
